'use strict';

/**
 * Toggles the clear (×) button visibility for a search input.
 *
 * @param {JQuery} $field
 */
function syncResetButton($field) {
	if (!$field || !$field.length) {
		return;
	}

	let hasValue = $field.val().length > 0;

	$field.closest('.site-search').toggleClass('has-value', hasValue);
	$field.siblings('.reset-button').toggleClass('d-none', !hasValue);
}

module.exports = {
	syncResetButton: syncResetButton
};
